export const validateCaptcha = () => {
  return new Promise((res, rej) => {
    globalThis.grecaptcha.ready(() => {
      globalThis.grecaptcha
        .execute("6LfvKVkaAAAAAESI0h4pDBJFA8CaEhIjlEQlCcST", {
          action: "submit",
        })
        .then((token) => {
          return res(token)
        })
    })
  })
}
